// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.log-popup-header{
  margin-left: 10px;
}

.log-popup-content{
margin: 26px 35px 50px 10px;
max-height: 500px;
overflow-y: auto;
}

.log-item {
  display: flex;
  align-items: start;
  margin-bottom: 32px;
  position: relative;
}

.log-timestamp {
  font-size: 12px;
  color: #6b6b6b;
  width: 85px;
  text-align: right;
  margin-right: 16px; 
  flex-shrink: 0;
}

.log-dot-wrapper {
  position: relative;
  display: flex;
  align-items: start;
  justify-content: start;
  flex-direction: column; 
  top: 6px;
  margin: 0 19px 0 21px;
}

.log-dot {
  width: 10px;
  height: 10px;
  background-color: #929292;
  border-radius: 50%;
  flex-shrink: 0;
  z-index: 1; 
}

.timeline-line {
  position: absolute;
  top: 7px; 
  left: 50%; 
  width: 1px;
  height: 190px; 
  background-color: #929292;
  z-index: 0; 
}

.log-details {
  display: flex;
  flex-direction: column;
  max-width: 480px;
}

.log-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.log-user {
  font-size: 12px;
  color: #6b6b6b;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/OrderLogPopup/OrderLogPopup.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;AACA,2BAA2B;AAC3B,iBAAiB;AACjB,gBAAgB;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB","sourcesContent":[".log-popup-header{\n  margin-left: 10px;\n}\n\n.log-popup-content{\nmargin: 26px 35px 50px 10px;\nmax-height: 500px;\noverflow-y: auto;\n}\n\n.log-item {\n  display: flex;\n  align-items: start;\n  margin-bottom: 32px;\n  position: relative;\n}\n\n.log-timestamp {\n  font-size: 12px;\n  color: #6b6b6b;\n  width: 85px;\n  text-align: right;\n  margin-right: 16px; \n  flex-shrink: 0;\n}\n\n.log-dot-wrapper {\n  position: relative;\n  display: flex;\n  align-items: start;\n  justify-content: start;\n  flex-direction: column; \n  top: 6px;\n  margin: 0 19px 0 21px;\n}\n\n.log-dot {\n  width: 10px;\n  height: 10px;\n  background-color: #929292;\n  border-radius: 50%;\n  flex-shrink: 0;\n  z-index: 1; \n}\n\n.timeline-line {\n  position: absolute;\n  top: 7px; \n  left: 50%; \n  width: 1px;\n  height: 190px; \n  background-color: #929292;\n  z-index: 0; \n}\n\n.log-details {\n  display: flex;\n  flex-direction: column;\n  max-width: 480px;\n}\n\n.log-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.log-user {\n  font-size: 12px;\n  color: #6b6b6b;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
